export default __webpack_public_path__ + "static/media/ETH.b3ec96d9.svg";